import React, { useMemo } from 'react';
// 使用样式
import 'echarts/theme/macarons';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { getSentimentColor, gradual } from '@/pages/opinion/utils/chart';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import { useIntl } from 'umi';
import { othersList } from '@op/pages/stats/constants';
export default function SentimentChart({
  chartData,
  filter,
  loading,
  height = 250,
  handleOnClick,
  transFunc = (name: string) => name,
  isTopic = false,
}: {
  chartData: any;
  filter: any;
  loading: boolean;
  height: number;
  handleOnClick?: any;
  transFunc?: (value: string) => string;
  isTopic: boolean;
}) {
  const { formatMessage } = useIntl();
  const options = useMemo(() => {
    if (!chartData) {
      return {};
    }
    const dataY: any = [];
    const dataSeries: any = [];
    let keepCurrentInfo: any = [];
    chartData.map((v: { name: string; avg_sentiment: number }) => {
      if (isTopic && othersList.includes(v.name)) return;
      dataY.push(transFunc(v.name));
      const value = v?.avg_sentiment?.toFixed(2);
      dataSeries.push({ value, originName: v.name });
      keepCurrentInfo.push(transFunc(v.name));
    });

    let option = {
      tooltip: {
        formatter: (params: any) => {
          return formatChartParamsDate({
            params: params,
            rightTitle: formatMessage({ id: 'Sentiment' }),
            listTitleFunc: (item) => item.axisValue,
            valueFormat: (value) => value,
          });
        },
      },
      xAxis: {
        axisLabel: {
          fontSize: 12,
        },
        splitLine: { show: false },
        axisTick: { show: false },
        type: 'value',
        max: 5,
      },
      yAxis: {
        inverse: true,
        axisLabel: {
          interval: 0,
          margin: 12,
          // formatter: (params: any) => {
          //   return chartLineFeed(params);
          // },
        },
        axisLine: { show: false },
        axisTick: { show: false },
        type: 'category',
        data: dataY,
      },
      color: ['#F17C86', '#6E7794', '#69D19C'],
      series: [
        {
          barMaxWidth: 30, // 最大宽度
          type: 'bar',
          label: {
            show: true,
            position: 'right',
            fontSize: 10,
          },
          data: dataSeries,
          itemStyle: {
            normal: {
              color: (params: { value: number }) => {
                return getSentimentColor(params.value);
              },
            },
          },
        },
      ],
      // visualMap: {
      //   type: 'continuous',
      //   orient: 'horizontal',
      //   left: 'center',
      //   min: 1,
      //   max: 5,
      //   itemWidth: 12,
      //   itemHeight: 164,
      //   text: ['5', 'Sentiment 1'],
      //   dimension: 0,
      //   inRange: {
      //     color: ['#F17C86', '#6E7794', '#69D19C'],
      //   },
      // },

      graphic: {
        elements: [
          {
            type: "group",
            left: "center",
            bottom: 2,
            silent: true,
            children: [
              // Negative
              {
                type: "circle",
                shape: { cx: 3.5, cy: 3.5, r: 3.5 },  // 12px circle
                style: { fill: "#F17C86" },
                y: -3,
                position: [0, 0],
              },
              {
                type: "text",
                style: {
                  text: formatMessage({ id: 'Negative' }),
                  fill: "#838697",
                  fontSize: 12,
                  textVerticalAlign: "middle",
                },
                position: [13, 0], // align text middle vertically
              },

              // Neutral
              {
                type: "circle",
                shape: { cx: 3.5, cy: 3.5, r: 3.5 },  // 12px circle
                style: { fill: "#6E7794" },
                y: -3,
                position: [80, 0],
              },
              {
                type: "text",
                style: {
                  text: formatMessage({ id: 'Neutral' }),
                  fill: "#838697",
                  fontSize: 12,
                  textVerticalAlign: "middle",
                },
                position: [93, 0],
              },

              // Positive
              {
                type: "circle",
                shape: { cx: 3.5, cy: 3.5, r: 3.5 },  // 12px circle
                style: { fill: "#69D19C" },
                y: -3,
                position: [160, 0],
              },
              {
                type: "text",
                style: {
                  text: formatMessage({ id: 'Positive' }),
                  fill: "#838697",
                  fontSize: 12,
                  textVerticalAlign: "middle",
                },
                position: [173, 0],
              },
            ],
          },
        ],
      },

    };
    return option;
  }, [chartData, filter, transFunc, formatMessage]);

  return (
    <EChartCommon
      optionsProps={{ type: 'bar', setMaxBarWidth: false }}
      empty={!chartData || chartData.length === 0}
      options={options}
      loading={loading}
      height={height + 18}
      eventsDict={{
        click: (params) => {
          // console.log(params);
          handleOnClick?.(params);
        },
      }}
    ></EChartCommon>
  );
}
